export default "https://cdn-static.gokick.com/assets/bd7d2df9c3fbba7be4a416b625ad3f88793f3763/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";